import React from 'react';

import cn from './style.module.sass';

type CustomMarkerProps = {
    title: string;
    lat: number;
    lng?: number;
    opacity?: number;
};

export default function CustomMarker({ title, opacity }: CustomMarkerProps) {
    return (
        <div className={cn['main-map__marker']} style={{ opacity: opacity }}>
            {title}
            <span className={cn['main-map__triangle']} />
        </div>
    );
}
